import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.video-process-cards' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--video-process-cards' )[0], {
          type: 'fade',
          pagination: true,
          arrows: false,
          gap: '32px',
          perPage: 1,
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'video-process-cards', COMPONENT );
} )( app );
